import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { uploadService } from '../../../../../services/uploadService';
import { Upload } from '../../../../../entities/upload';
import { NewsService } from '../../../../../services/newsService';
@Component({
  selector: 'app-addnews',
  templateUrl: './addnews.component.html',
  styleUrls: ['./addnews.component.css']
})
export class AddnewsComponent implements OnInit {

  files: any;;

  HeadNews = '';
  detailNews1 = '';
  TitleNews = '';
  TypeNewspromotion = '';
  url;

  currentUploadNews: Upload;
  filesToUpload;
  constructor(public upSvc: uploadService, private nSv: NewsService, private _location: Location) { }

  ngOnInit() {
  }
  backClicked() {
    this._location.back();
  }
  fileChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0] && fileInput.target.files.length > 0) {
      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.url = event.target.result;
      }
      reader.readAsDataURL(fileInput.target.files[0]);
    }
    this.filesToUpload = fileInput.target.files;
  }
  addNews() {
    this.files = this.filesToUpload;
    let newsTemp = this.nSv.getNewsPomotions();
    let idcount;
    let dataNews;
    newsTemp.subscribe((snap) => {
      console.log(snap)
      if(snap.length == 0){
        console.log("function 1","ss")
        if (this.HeadNews != '' && this.TitleNews != '' && this.TypeNewspromotion != '') {
          dataNews = {
            id:1,
            Head: this.HeadNews,
            TitleNews: this.TitleNews,
            detail1: this.detailNews1,
            detail2: '',
            detail3: '',
            detail4: '',
            type: this.TypeNewspromotion,
            photoTitle: '',
            photo1: '',
            photo2: '',
            photo3: '',
            photo4: ''
          }
          // Check Upload Call Function 1 
          // if (this.files.length != null) {
          //   // Variable File Image Upload
          //   let fileTitle = this.files.item(0)
          //   this.currentUploadNews = new Upload(fileTitle);
          //   this.upSvc.addMoreManyImageNewTitle(dataNews, this.currentUploadNews)
          // } 
          
        }
      }else{
        idcount = snap[snap.length-1].id + 1
        console.log("function 2",idcount)
        if (this.HeadNews != '' && this.TitleNews != '' && this.TypeNewspromotion != '') {
         dataNews = {
            id:idcount,
            Head: this.HeadNews,
            TitleNews: this.TitleNews,
            detail1: this.detailNews1,
            detail2: '',
            detail3: '',
            detail4: '',
            type: this.TypeNewspromotion,
            photoTitle: '',
            photo1: '',
            photo2: '',
            photo3: '',
            photo4: ''
          }
          
          //Check Upload Call Function 1 
          if (this.files.length != null) {
            //console.log("function 11")
            // Variable File Image Upload
            let fileTitle = this.files.item(0)
            this.currentUploadNews = new Upload(fileTitle);
            this.upSvc.addMoreManyImageNewTitle(dataNews, this.currentUploadNews)
          }
          
        }
      }
    })


  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/news/view/addnews/addnews.component.ts